import { addToCartMethod } from '@Components/Common/CommonMethods';
import DialogComponent from '@Components/Common/DialogComponent';
import Cookies from 'js-cookie';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

const AncestryDnaPopup = styled.div`
   .main-popup {
        text-align: center;
    }
      .dna-testkit {
        display: flex;
        justify-content: center;
        gap: 20px;
    }
    .ancestry-line{
        font-style: italic;
    }
    button.choose-complex {
        background: #5cb5be;
        color: #fff;
        width: 100%;
        max-width: fit-content;
        font-size: 18px;
        font-weight: 700;
        border-radius: 100px;
    }
   `;

const CommonDialogPopup = ({ openKitAncestry, setOpenKitAncestry, FormulahandleAddKitProduct, FormulahandleAddKitProductAncestry, props }) => {
    const [cartNotify, setCartNotify] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    function handleKitAdd() {
        addToCartMethod(
            {
                id: 1,
                quantity: 1,
                is_autoship: false
            },
            props?.setshowminicart,
            setCartNotify,
            props?.cartdata?.products,
            props?.setCartData,
            false,
            setErrorMsg,
        )
        Cookies.remove("ancestryon")
        setOpenKitAncestry(false)
    };
    const GETDATA = Cookies.get("ancestryon");
    const router = useRouter();
    return (
        <DialogComponent opend={openKitAncestry} handleClose={() => setOpenKitAncestry(false)} classFor="ancestry_dnakit">
            <AncestryDnaPopup>
                <div className='main-popup'>
                    <p className='popup-dna-data'>
                        You are about to unlock your personalized supplement formula (Supplement Facts Panel) by entering your DNA data.
                    </p>
                    <div className='ancestry-data'>
                        <p>
                            This purchase includes a Premium<a href='https://admin.snipnutrition.com/media/documents/DNA_Sample_Reports.pdf' target='_blank'><b> C.O.D.E. Report</b></a> and one-page <a href='https://admin.snipnutrition.com/media/documents/DNA_summary_report.pdf' target='_blank'><b>Summary DNA Health Report.</b></a>
                        </p>
                    </div>
                    <p className='ancestry-line'>Ten key health reports and the 103-SNP allele report are only included with the purchase of a home DNA Test Kit ($297).</p>
                </div>
                <div className='dna-testkit'>
                    <button type="button" className="choose-complex" onClick={GETDATA ? FormulahandleAddKitProductAncestry : FormulahandleAddKitProduct}>Proceed to Checkout</button>
                    <button type="button" className="choose-complex" onClick={() => handleKitAdd()}>Exit to Purchase Home DNA Test Kit</button>
                </div>
            </AncestryDnaPopup>
        </DialogComponent>
    )
}

export default CommonDialogPopup